import { Group } from '@visx/group';
import { useRef, useState } from 'react';
import { useMount } from '@simplywallst/ui-core';
import { SankeyWrapper } from './styled';
import { retriableCalcSankeyData } from './hooks/useSankey';
import type { RawDataType } from './hooks/useSankey';
import { useTheme } from '@simplywallst/ui-core';
import { Sankey } from './Sankey';
import type { CurrencyISO } from '@/constants/currencies';
interface Props {
  rawData: RawDataType;
  currencyISO: CurrencyISO;
}

const SankeyContent = ({ rawData, currencyISO }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const chartPadding = { top: 60, left: 5, right: 0, bottom: 25 };
  const theme = useTheme();

  const [chartWidth, setChartWidth] = useState(
    theme.mdMinRaw - chartPadding.left - chartPadding.right
  );
  const chartHeight = 500;
  const initWidth = chartWidth - chartPadding.left - chartPadding.right;
  const initHeight = chartHeight - chartPadding.top - chartPadding.bottom;

  // Update chart width when the container element is mounted
  useMount(() => {
    if (containerRef.current) {
      const { width } = containerRef.current.getBoundingClientRect();
      const widthWithBound = Math.max(
        width,
        theme.mdMinRaw - chartPadding.left - chartPadding.right
      );
      setChartWidth(widthWithBound);
    }
  });

  const { data: sankeyData, chartHeight: calculatedChartHeight } =
    retriableCalcSankeyData({
      rawData,
      width: initWidth,
      height: initHeight,
    });

  const chartPaddingTop =
    chartPadding.top +
    (chartHeight -
      chartPadding.top -
      chartPadding.bottom -
      calculatedChartHeight) /
      2;

  return (
    <SankeyWrapper
      ref={containerRef}
      id="revenue-and-expenses-breakdown-chart-loaded-content"
    >
      <svg width={chartWidth} height={chartHeight}>
        <Group top={chartPaddingTop} left={chartPadding.left}>
          <Sankey sankeyData={sankeyData} currencyISO={currencyISO} />
        </Group>
      </svg>
    </SankeyWrapper>
  );
};

export default SankeyContent;
